import {EnvironmentType} from '../app/models/environment.type';

export const environment: EnvironmentType = {
  production: false,
  apiPrefix: '/ws/',
  socketPrefix: '',
  language: 'en',
  about: { version: require('../../package.json').version, buildDate: 1791382500129 }
};
